// Two-column docs chrome: sticky left sidebar reads from nav.json, right
// pane renders the active page's MDX. Matches .impeccable/shapes/docs-layout.md
// — Terracotta restricted to the brand mark + the 1px active-page rail.

import { Link, NavLink, Outlet } from 'react-router-dom'
import { NAV } from '../../docs/registry.js'

function sidebarItemClass({ isActive }) {
  return [
    'block py-1.5 pl-4 -ml-px text-sm transition-colors',
    isActive
      ? 'text-[var(--color-basalt)] border-l border-[var(--color-terracotta)] font-medium'
      : 'text-[var(--color-slate)] border-l border-transparent hover:text-[var(--color-basalt)] hover:border-[var(--color-schist)]',
  ].join(' ')
}

export function DocsLayout() {
  return (
    <div className="min-h-screen bg-[var(--color-limestone)]">
      <header className="sticky top-0 z-30 border-b border-[var(--color-sandstone)] bg-[var(--color-limestone)]/95 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-6">
          <Link to="/" className="font-medium tracking-tight text-[var(--color-terracotta)]">
            cairn
          </Link>
          <nav className="flex items-center gap-5 text-sm text-[var(--color-slate)]">
            <Link to="/docs" className="hover:text-[var(--color-basalt)]">
              Docs
            </Link>
            <Link to="/teams" className="hover:text-[var(--color-basalt)]">
              Dashboard
            </Link>
            <a
              href="https://github.com/cairntools/cairn"
              className="hover:text-[var(--color-basalt)]"
            >
              GitHub
            </a>
          </nav>
        </div>
      </header>

      <div className="mx-auto flex max-w-7xl gap-12 px-6 py-10">
        <aside aria-label="Docs navigation" className="hidden w-64 shrink-0 lg:block">
          <nav className="sticky top-24">
            {NAV.sections.map((section) => (
              <section key={section.title} className="mb-8">
                <h2 className="mb-2 text-xs font-medium uppercase tracking-wider text-[var(--color-schist)]">
                  {section.title}
                </h2>
                <ul className="border-l border-[var(--color-sandstone)]">
                  {section.items.map((item) => (
                    <li key={item.slug}>
                      <NavLink to={`/docs/${item.slug}`} className={sidebarItemClass}>
                        {item.label}
                        {item.generated && (
                          <span
                            title="auto-generated at build time"
                            className="ml-2 text-[10px] text-[var(--color-schist)]"
                          >
                            auto
                          </span>
                        )}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </nav>
        </aside>

        <main id="main-content" className="prose-pane min-w-0 flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
